<template>
    <div>
        <h6 v-if="(profileId == 0)" class="heading-small text-muted mb-4">Add New Payment Type {{ (inputName) ? (" - " + this.inputName) : "" }}</h6>
        <h6 v-else class="heading-small text-muted mb-4">Edit Payment Type - {{this.inputName}}</h6>
        
        <a-drawer title="" :width="460" placement="right" @close="onCloseDrawerField" :visible="drawerFieldVisible">
            <h6 class="heading-small text-muted mb-4">POS Field Management</h6>
            <base-input v-model="posField.label" alternative="" label="Label" placeholder=""  input-classes="form-control" />
            <base-input v-model="posField.name" alternative="" label="Name" placeholder="" input-classes="form-control" />
            <!-- @select="e => handleChange(e, record.key, col)" -->
            <base-input alternative="" label="Data Type">
                <a-select style="width: 100%" placeholder="Select input type" v-model="posField.data_type">
                  <a-select-option v-for="inputType in formDataTypes" :key="inputType" :value="inputType">{{inputType}}</a-select-option>
                </a-select>
            </base-input>

            <base-input alternative="" label="Tag to available field">
                <a-select style="width: 100%" placeholder="Select input type" v-model="posField.field_tag_name">
                    <a-select-option key="reference_code" value="reference_code">Reference Code</a-select-option>
                    <a-select-option key="remark" value="remark">Remark</a-select-option>
                    <a-select-option key="approval_code" value="approval_code">Approval Code</a-select-option>
                </a-select>
            </base-input>

            <base-input v-if='posField.data_type == "string"' v-model="posField.maxCharLength" alternative="" label="Max Character Length" type="nu,ber" input-classes="form-control" />
            

            <base-input v-if='posField.data_type == "select"' alternative="" label="Options" >
                <a-select  mode="tags" class="col-12 mt-2" v-model='posField.options' style="width: 100%;" placeholder='Please define order sources' input-classes="form-control"></a-select>  
            </base-input>

            <base-input v-if='posField.data_type == "lookup"' v-model="posField.model" alternative="" label="Model" placeholder=""  input-classes="form-control" />

            
            <base-checkbox class="mb-3" v-model="posField.is_required">
                Require this field
            </base-checkbox>

            <div>
                <button type="button" class="btn btn-primary float-right" @click.prevent="savePosFields">Save</button> 
                <!-- <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button>  -->
            </div>

        </a-drawer>

        <base-alert v-if="errors.length" type="danger">
            <b>You have the following error(s):</b>
            <li v-for="error in errors" :key="error">{{ error }}</li>
        </base-alert>

        <form id="form-proper">
            <div>
                <a-tabs defaultActiveKey="1">
                    <a-tab-pane tab="Basic" key="1">
                        <base-input alternative="" label="Code" placeholder="" v-model="inputCode"  input-classes="form-control" :disabled="!isAdmin" />
                        <base-input alternative="" label="Name" placeholder="" v-model="inputName" input-classes="form-control" required />
                        <base-input alternative="" label="Remark">
                            <textarea rows="4" class="form-control" v-model="inputRemark" />
                        </base-input>
                        
                        <br><br>
                    </a-tab-pane>
                    <a-tab-pane tab="CRM" key="2" forceRender>
                        <base-input alternative="" label="Conversion Rate" placeholder="" v-model="inputConversionRate" input-classes="form-control" required />
                        <base-input alternative="" label="Amount Sold per Point" placeholder="" v-model="inputAmountSoldPerPoint" input-classes="form-control" required />
                        <base-input alternative="" label="Minimum & Multiple Amount Sold" placeholder="" v-model="inputMinAndMultipleAmtSold" input-classes="form-control" required />
                    </a-tab-pane>
                    <!-- <a-tab-pane tab="Add On" key="3" forceRender>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableAddon" :disabled="$attrs.viewMode == true">
                            Enable Add-on for this Payment Type
                        </base-checkbox>
                    </a-tab-pane> -->
                    <a-tab-pane tab="Settings" key="3" forceRender>
                        
                        <base-checkbox class="mb-3" v-model="checkboxes.isIncludeInPos" :disabled="$attrs.viewMode == true">
                            Include this payment type in POS
                        </base-checkbox>
                        <!-- <base-checkbox class="mb-3" v-model="checkboxes.isReqSupervisorAuth" :disabled="$attrs.viewMode == true">
                            Requires the supervisor authorization
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isReqSupervisorOvrMax" :disabled="$attrs.viewMode == true">
                            Requires supervisor to override maximum limit
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isReqReferenceCode" :disabled="$attrs.viewMode == true">
                            Requires reference code
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isReqApprovalCode" :disabled="$attrs.viewMode == true">
                            Requires approval code
                        </base-checkbox> -->
                        <base-checkbox class="mb-3" v-model="checkboxes.withIntegration" :disabled="$attrs.viewMode == true">
                            Enable Integration for this Payment Type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAccountReceivable" :disabled="$attrs.viewMode == true">
                            Flag this payment type as account receivable
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.openCashDrawer" :disabled="$attrs.viewMode == true">
                            Open cash drawer on use of this payment type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.openCashDrawerOnTenderCheck" :disabled="$attrs.viewMode == true">
                            Open cash drawer when tender is greater than or equal amount due
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.restrictTenderAmount" :disabled="$attrs.viewMode == true">
                            Do not allow tender to be more than amount due 
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.enableMultipleSplit" :disabled="$attrs.viewMode == true">
                            Enable Multiple Split Payment
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableAddon" :disabled="$attrs.viewMode == true">
                            Enable Add-on for this Payment Type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isPrintDuplicateReceipt" :disabled="$attrs.viewMode == true">
                            Print duplicate receipt for this type of payment
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isPrintTripleReceipt" :disabled="$attrs.viewMode == true">
                            Print triplicate receipt for this type of payment
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isPrintSignatureLine" :disabled="$attrs.viewMode == true">
                            Print a signature line to this type of payment
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isPrintValidationSlip" :disabled="$attrs.viewMode == true">
                            Print validation slip when this type of payment is used
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowSeniorCitizen" :disabled="$attrs.viewMode == true">
                            Allow senior citizen for this payment type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isAllowDisabledPerson" :disabled="$attrs.viewMode == true">
                            Allow disabled person discount for this payment type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isPrintGroceryBreakdown" :disabled="$attrs.viewMode == true">
                            Print grocery and non-grocery breakdown
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableContinuousUsage" :disabled="$attrs.viewMode == true">
                            Enable continuous usage of this payment type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRememberLastFiled" :disabled="$attrs.viewMode == true">
                            Remember last filed information
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isNoSalesCommission" :disabled="$attrs.viewMode == true">
                            No sales commission
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isLimitUsage" :disabled="$attrs.viewMode == true">
                            Limit the usage of this payment type
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isEnableAutoComputeBalance" :disabled="$attrs.viewMode == true">
                            Enable auto-compute balance
                        </base-checkbox>
                        <base-checkbox class="mb-3" v-model="checkboxes.isRequireReferenceCode" :disabled="$attrs.viewMode == true">
                            Require Reference Code
                        </base-checkbox>
                        <br><br>
                    </a-tab-pane>

                    <a-tab-pane tab="POS Fields" key="4" forceRender>
                            <button type="button" class="btn btn-sm btn-success float-right" @click.prevent="openDrawerField({})"> + Add Field </button> <br/><br/>
                            <a-table :columns="conditionColumns" :dataSource="posFields" bordered>
                                <template slot="operation" slot-scope="text, record">
                                    <a-dropdown>
                                      <a class="ant-dropdown-link" href="#">
                                        <span class="fa fa-ellipsis-v"></span> 
                                      </a>
                                      <a-menu slot="overlay">
                                          <!-- @click="headerAction(header, 1)" -->
                                        <a-menu-item key=1 @click="openDrawerField(record)"> Edit {{record.label}} </a-menu-item>
                                        <a-menu-item key=2 > 
                                          <!-- @confirm="headerAction(header, 2)" -->
                                          <a-popconfirm title="You are about to delete this header?" @confirm="deletPosField(record)"  okText="Delete" cancelText="Cancel">
                                            Delete {{record.label}}
                                          </a-popconfirm>
                                        </a-menu-item>
                                      </a-menu>
                                    </a-dropdown>
                                </template>
                            </a-table>
                    </a-tab-pane>
                </a-tabs>
            </div>
            <div v-if="this.$attrs.viewMode != true">
                <div v-if="serverType == 'ho'" style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button v-if="(profileId == 0)" type="button" class="btn btn-primary float-right" @click.prevent="create">Create</button> 
                    <button v-else type="button" class="btn btn-primary float-right" @click.prevent="update">Update</button> 
                </div>
                <div v-else style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
                    <button type="button" class="btn btn-primary float-right" @click.prevent="$emit('closeDrawer', null)">Close</button> 
                </div>
            </div>
        </form>
    </div>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import ValidateField from '../../components/validateFormUtils.js'
    import secureStorage from '../../controllers/secureStorage.js'
    import { mapState } from 'vuex'
    var component_x;
    export default {
        computed: {
            ...mapState(['endPoint', 'profileId', 'serverType']),
        },
        mounted: async function () {
            if(this.serverType == 'branch' || this.$attrs.viewMode == true){
                var form = document.getElementById("form-proper")
                var elements = form.elements;
                for (var i = 0, len = elements.length; i < len; ++i) {
                    elements[i].readOnly = true;
                }
            }
            this.accountId = this.$attrs.accountId;
            component_x = this
            if (this.profileId > 0) {
                if(this.accountId == undefined){
                    var payment_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'payment_types/' + component_x.profileId , null)
                } else {
                    var payment_type_data = await HTTPRequest.getRequest(component_x.endPoint + 'payment_types/' + component_x.profileId + "?account_id=" + this.accountId , null)
                }

                if (payment_type_data == undefined) {
                    alert("SOMETHING WENT WRONG")
                    // component_x.$router.go()
                } else {
                    if (payment_type_data["error"] == undefined) {
                        component_x.inputName = payment_type_data["name"]
                        component_x.inputCode = payment_type_data["code"]
                        component_x.inputRemark = payment_type_data["remark"]
                        component_x.checkboxes.isIncludeInPos = payment_type_data["is_include_in_pos"]
                        component_x.checkboxes.isReqSupervisorAuth = payment_type_data["is_req_supervisor_auth"]
                        component_x.checkboxes.isReqSupervisorOvrMax = payment_type_data["is_req_supervisor_ovr_max"]
                        component_x.checkboxes.isReqReferenceCode = payment_type_data["is_req_reference_code"]
                        component_x.checkboxes.isReqApprovalCode = payment_type_data["is_req_approval_code"]
                        component_x.checkboxes.isPrintDuplicateReceipt = payment_type_data["is_print_duplicate_receipt"]
                        component_x.checkboxes.isPrintTripleReceipt = payment_type_data["is_print_triple_receipt"]
                        component_x.checkboxes.isPrintSignatureLine = payment_type_data["is_print_signature_line"]
                        component_x.checkboxes.isPrintValidationSlip = payment_type_data["is_print_validation_slip"]
                        component_x.checkboxes.isAllowSeniorCitizen = payment_type_data["is_allow_senior_citizen"]
                        component_x.checkboxes.isAllowDisabledPerson = payment_type_data["is_allow_disabled_person"]
                        component_x.checkboxes.isPrintGroceryBreakdown = payment_type_data["is_print_grocery_breakdown"]
                        component_x.checkboxes.isEnableContinuousUsage = payment_type_data["is_enable_continuous_usage"]
                        component_x.checkboxes.isRememberLastFiled = payment_type_data["is_remember_last_filed"]
                        component_x.checkboxes.isNoSalesCommission = payment_type_data["is_no_sales_commission"]
                        component_x.checkboxes.isLimitUsage = payment_type_data["is_limit_usage"]
                        component_x.checkboxes.isEnableAddon = payment_type_data["is_enable_addon"]
                        component_x.checkboxes.withIntegration = payment_type_data["with_integration"]
                        component_x.checkboxes.isAccountReceivable = payment_type_data["is_account_receivable"]
                        component_x.checkboxes.openCashDrawer = payment_type_data["open_cash_drawer"]
                        component_x.inputConversionRate = payment_type_data["conversion_rate"]
                        component_x.inputAmountSoldPerPoint = payment_type_data["amount_sold_per_point"]
                        component_x.inputMinAndMultipleAmtSold = payment_type_data["min_and_multiple_amt_sold"]
                        component_x.checkboxes.openCashDrawerOnTenderCheck = payment_type_data["open_drawer_on_tender_check"]
                        component_x.checkboxes.restrictTenderAmount = payment_type_data["restrict_tender_amount"]
                        component_x.checkboxes.enableMultipleSplit = payment_type_data["enable_multiple_split"]
                        component_x.checkboxes.isEnableAutoComputeBalance = payment_type_data["enable_auto_compute_balance"]
                        component_x.checkboxes.isRequireReferenceCode = payment_type_data["is_req_reference_code"]
                        component_x.posFields = JSON.parse(payment_type_data["extras"])
                    } else {
                        this.errors = payment_type_data["error"].split(",")
                    }
                }
            }
        },
        data: function () {
            return {
                posField: {},
                inputName: '',
                inputCode: '',
                inputRemark: '',
                checkboxes: {
                    enableMultipleSplit: false,
                    openCashDrawerOnTenderCheck: false,
                    restrictTenderAmount: false,
                    isIncludeInPos: false,
                    isReqSupervisorAuth: false,
                    isReqSupervisorOvrMax: false,
                    isReqReferenceCode: false,
                    isReqApprovalCode: false,
                    isPrintDuplicateReceipt: false,
                    isPrintTripleReceipt: false,
                    isPrintSignatureLine: false,
                    isPrintValidationSlip: false,
                    isAllowSeniorCitizen: false,
                    isAllowDisabledPerson: false,
                    isPrintGroceryBreakdown: false,
                    isEnableContinuousUsage: false,
                    isRememberLastFiled: false,
                    isNoSalesCommission: false,
                    isLimitUsage: false,
                    isEnableAddon: false,
                    withIntegration: false
                },
                inputConversionRate: '',
                inputAmountSoldPerPoint: '',    
                inputMinAndMultipleAmtSold: '',
                errors: [],
                accountId: 0,
                conditionColumns: [
                    {
                      title: 'Label',
                      dataIndex: 'label',
                    //   width: '40%',
                      scopedSlots: { customRender: 'label' },
                    },
                    {
                      title: 'Name',
                      dataIndex: 'name',
                    //   width: '40%',
                      scopedSlots: { customRender: 'name' },
                    },
                    {
                      title: 'Data Type',
                      dataIndex: 'data_type',
                    //   width: '40%',
                      scopedSlots: { customRender: 'data_type' },
                    },
                    {
                      title: '',
                      dataIndex: 'operation',
                      width: '20%',
                      scopedSlots: { customRender: 'operation' },
                    },
                ],
                posFields: [],
                drawerFieldVisible: false,
                formDataTypes: ["string", "integer", "double", "boolean", "datetime", "select", "lookup"] ,
                isAdmin: secureStorage.getItem("isRippleAdmin")
            }
        },
        methods: {
            deletPosField(record){
                const indexToDelete = this.posFields.findIndex(n => n.name === record.name);
                if (indexToDelete !== -1) {
                    // alert(indexToDelete)
                    this.posFields.splice(indexToDelete, 1);
                }
            },
            savePosFields(){
                if (this.posFields == null)
                    this.posFields = []
                const indexToUpdate = this.posFields.findIndex(n => n.name === this.posField.name);
                if (indexToUpdate !== -1) {
                  this.posFields[indexToUpdate] = this.posField
                }else{
                    this.posFields.push(this.posField)
                }
                this.posField = {}
                this.drawerFieldVisible = false
            },
            openDrawerField(posField){
                this.posField = posField
                if(_.isUndefined(this.posField.maxCharLength))
                    this.posField.maxCharLength = 0
                if(_.isUndefined(this.posField.minCharLength))
                    this.posField.minCharLength = 0
                this.drawerFieldVisible = true;
            },
            onCloseDrawerField(){
                this.drawerFieldVisible = false;
            },
            validateForm(){
                this.errors = [];
                // this.errors.push(ValidateField.required('Code', this.inputCode));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Code', this.inputCode));
                this.errors.push(ValidateField.charMinAndMax('Code', this.inputCode, 0, 30));
                this.errors.push(ValidateField.required('Name', this.inputName));
                // this.errors.push(ValidateField.alphanumericWithSpecialChars('Name', this.inputName));
                this.errors.push(ValidateField.charMinAndMax('Name', this.inputName, 0, 50));
                this.errors.push(ValidateField.decimalFormat('Conversion Rate', this.inputConversionRate));
                this.errors.push(ValidateField.decimalFormat('Amount Sold per Point', this.inputAmountSoldPerPoint));
                this.errors.push(ValidateField.decimalFormat('Minimum & Multiple Amount Sold', this.inputMinAndMultipleAmtSold));
                this.errors = this._.compact(this.errors);
                document.getElementsByClassName('ant-drawer-wrapper-body')[0].scrollTop = 0;
                return this.errors.length;
            },
            create: async function () {
                if(!this.validateForm()) {
                    var payment_typePayload = {
                        payment_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                            status: 'A',
                            is_include_in_pos: this.checkboxes.isIncludeInPos,
                            is_req_supervisor_auth: this.checkboxes.isReqSupervisorAuth,
                            is_req_supervisor_ovr_max: this.checkboxes.isReqSupervisorOvrMax,
                            is_req_reference_code: this.checkboxes.isReqReferenceCode,
                            is_req_approval_code: this.checkboxes.isReqApprovalCode,
                            is_print_duplicate_receipt: this.checkboxes.isPrintDuplicateReceipt,
                            is_print_triple_receipt: this.checkboxes.isPrintTripleReceipt,
                            is_print_signature_line: this.checkboxes.isPrintSignatureLine,
                            is_print_validation_slip: this.checkboxes.isPrintValidationSlip,
                            is_allow_senior_citizen: this.checkboxes.isAllowSeniorCitizen,
                            is_allow_disabled_person: this.checkboxes.isAllowDisabledPerson,
                            is_print_grocery_breakdown: this.checkboxes.isPrintGroceryBreakdown,
                            is_enable_continuous_usage: this.checkboxes.isEnableContinuousUsage,
                            is_remember_last_filed: this.checkboxes.isRememberLastFiled,
                            is_no_sales_commission: this.checkboxes.isNoSalesCommission,
                            is_account_receivable: this.checkboxes.isAccountReceivable,
                            open_cash_drawer: this.checkboxes.openCashDrawer,
                            is_limit_usage: this.checkboxes.isLimitUsage,
                            conversion_rate: this.inputConversionRate,
                            amount_sold_per_point: this.inputAmountSoldPerPoint,
                            min_and_multiple_amt_sold: this.inputMinAndMultipleAmtSold,
                            is_enable_addon: this.checkboxes.isEnableAddon,
                            with_integration: this.checkboxes.withIntegration,
                            open_drawer_on_tender_check: this.checkboxes.openCashDrawerOnTenderCheck,
                            restrict_tender_amount: this.checkboxes.restrictTenderAmount,
                            enable_multiple_split: this.checkboxes.enableMultipleSplit,
                            enable_auto_compute_balance: this.checkboxes.isEnableAutoComputeBalance,
                            is_req_reference_code: this.checkboxes.isRequireReferenceCode,
                            extras: JSON.stringify(this.posFields)
                        }
                    }
                    var post_request = await HTTPRequest.postRequest(this.endPoint + 'payment_types?account_id=' + this.accountId, null, payment_typePayload)
                    if (post_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (post_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = post_request["error"].split(",")
                        }
                    }
                }
            },
            update: async function () {
                if(!this.validateForm()) {
                    var payment_typePayload = {
                        payment_type: {
                            name: this.inputName.trim(),
                            code: this.inputCode.trim(),
                            remark: this.inputRemark,
                            is_include_in_pos: this.checkboxes.isIncludeInPos,
                            is_req_supervisor_auth: this.checkboxes.isReqSupervisorAuth,
                            is_req_supervisor_ovr_max: this.checkboxes.isReqSupervisorOvrMax,
                            is_req_reference_code: this.checkboxes.isReqReferenceCode,
                            is_req_approval_code: this.checkboxes.isReqApprovalCode,
                            is_print_duplicate_receipt: this.checkboxes.isPrintDuplicateReceipt,
                            is_print_triple_receipt: this.checkboxes.isPrintTripleReceipt,
                            is_print_signature_line: this.checkboxes.isPrintSignatureLine,
                            is_print_validation_slip: this.checkboxes.isPrintValidationSlip,
                            is_allow_senior_citizen: this.checkboxes.isAllowSeniorCitizen,
                            is_allow_disabled_person: this.checkboxes.isAllowDisabledPerson,
                            is_print_grocery_breakdown: this.checkboxes.isPrintGroceryBreakdown,
                            is_enable_continuous_usage: this.checkboxes.isEnableContinuousUsage,
                            is_remember_last_filed: this.checkboxes.isRememberLastFiled,
                            is_no_sales_commission: this.checkboxes.isNoSalesCommission,
                            is_account_receivable: this.checkboxes.isAccountReceivable,
                            open_cash_drawer: this.checkboxes.openCashDrawer,
                            is_limit_usage: this.checkboxes.isLimitUsage,
                            conversion_rate: this.inputConversionRate,
                            amount_sold_per_point: this.inputAmountSoldPerPoint,
                            min_and_multiple_amt_sold: this.inputMinAndMultipleAmtSold,
                            is_enable_addon: this.checkboxes.isEnableAddon,
                            with_integration: this.checkboxes.withIntegration,
                            open_drawer_on_tender_check: this.checkboxes.openCashDrawerOnTenderCheck,
                            restrict_tender_amount: this.checkboxes.restrictTenderAmount,
                            enable_multiple_split: this.checkboxes.enableMultipleSplit,
                            enable_auto_compute_balance: this.checkboxes.isEnableAutoComputeBalance,
                            is_req_reference_code: this.checkboxes.isRequireReferenceCode,
                            extras: JSON.stringify(this.posFields)
                        }
                    }
                    var put_request = await HTTPRequest.putRequest(this.endPoint + 'payment_types/' + this.profileId + "?account_id=" + this.accountId, null, payment_typePayload)
                    if (put_request == undefined) {
                        this.$emit('refreshPage', event)
                    } else {
                        if (put_request["error"] == undefined) {
                            this.$emit('refreshPage', event)
                        } else {
                            this.errors = put_request["error"].split(",")
                        }
                    }
                }
            }
        }
    }
</script>

<style></style
